import { Component } from '@angular/core';

@Component({
  selector: 'app-notimplemented',
  imports: [],
  templateUrl: './notimplemented.component.html',
  styleUrl: './notimplemented.component.scss',
})
export class NotimplementedComponent {}
